import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

// Botón principal visible + menú "⋮" para el resto de acciones de una fila,
// evitando saturar la tabla con muchos botones sueltos.
const RowActionsMenu = ({ primary, actions = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const visibleActions = actions.filter((action) => action && !action.hidden);

  const handleSelect = (action) => {
    setAnchorEl(null);
    action.onClick();
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 0.5 }}>
      {primary && !primary.hidden && (
        <Button
          size="small"
          variant={primary.variant || "contained"}
          color={primary.color || "primary"}
          onClick={primary.onClick}
          disabled={primary.disabled}
        >
          {primary.label}
        </Button>
      )}

      {visibleActions.length > 0 && (
        <>
          <Tooltip title="Más acciones">
            <span>
              <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
                <MoreVertIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
            {visibleActions.map((action) => (
              <MenuItem
                key={action.label}
                onClick={() => handleSelect(action)}
                disabled={action.disabled}
                sx={action.color ? { color: `${action.color}.main` } : undefined}
              >
                {action.icon && <ListItemIcon>{action.icon}</ListItemIcon>}
                <ListItemText>{action.label}</ListItemText>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Box>
  );
};

export default RowActionsMenu;
